import Api from 'Helpers/api';

const FurnituresCategories = {
	get: async () => {
		const response = await Api.call('get', '/furnitures-categories');
		return response.data;
	}
};

export default FurnituresCategories;
